import { render } from "./Tapume.vue?vue&type=template&id=58d637dc&scoped=true"
import script from "./Tapume.vue?vue&type=script&lang=js"
export * from "./Tapume.vue?vue&type=script&lang=js"

import "./Tapume.vue?vue&type=style&index=0&id=58d637dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d637dc"]])

export default __exports__